import Route from '@ember/routing/route';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import BalanceAdjustmentModel from 'donor-elf-web/models/admin/balance-adjustment';
import FundModel from 'donor-elf-web/models/fund';

export interface BalanceAdjustmentItem {
  balanceAdjustment: BalanceAdjustmentModel;
  fund: FundModel;
}

export interface BalanceAdjustmentRouteModel {
  items: BalanceAdjustmentItem[];
}

export default class BalanceAdjustmentRoute extends Route {
  @service declare store: Store;
  @service declare storeCache: any;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Balance Adjustments';
  }

  async model(): Promise<BalanceAdjustmentRouteModel> {
    let fundsById = await this.storeCache.indexSingleBy('admin/fund', 'id');
    let balanceAdjustments = await this.store.findAll(
      'admin/balance-adjustment',
    );
    return {
      items: balanceAdjustments.map((balanceAdjustment) => {
        return {
          balanceAdjustment,
          fund: fundsById[balanceAdjustment.fundId] as FundModel,
        };
      }),
    };
  }
}
